import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'hf-custom-spinner',
  templateUrl: './custom-spinner.component.html',
  styleUrls: ['./custom-spinner.component.scss']
})
export class CustomSpinnerComponent implements OnInit {
  @Input() public saveButton = true;
  @Input() public sidepaneLoading = false;
  @Input() public darkTheme?: boolean = true;
  @Input() public primaryTheme = false;

  constructor() {}

  ngOnInit() {}
}
